
import { useState } from 'react';
import Layout from '../../../components/feature/Layout';

interface Document {
  id: string;
  nombre: string;
  tipo: string;
  operacion: string;
  cliente: string;
  carpeta: string;
  tamaño: string;
  fechaSubida: string;
  subidoPor: string;
  estado: 'vigente' | 'vencido' | 'pendiente';
}

const documentsData: Document[] = [
  {
    id: '1',
    nombre: 'BL_MAERSK_2024001823.pdf',
    tipo: 'Bill of Lading',
    operacion: 'OP-2024-1823',
    cliente: 'Importadora Global S.A.',
    carpeta: 'BL/AWB',
    tamaño: '2.4 MB',
    fechaSubida: '2024-01-15',
    subidoPor: 'María González',
    estado: 'vigente'
  },
  {
    id: '2',
    nombre: 'FACTURA_COMERCIAL_1823.pdf',
    tipo: 'Factura Comercial',
    operacion: 'OP-2024-1823',
    cliente: 'Importadora Global S.A.',
    carpeta: 'Facturas',
    tamaño: '1.8 MB',
    fechaSubida: '2024-01-15',
    subidoPor: 'María González',
    estado: 'vigente'
  },
  {
    id: '3',
    nombre: 'DUCA_GT_2024_001823.pdf',
    tipo: 'DUCA',
    operacion: 'OP-2024-1823',
    cliente: 'Importadora Global S.A.',
    carpeta: 'DUCA',
    tamaño: '3.2 MB',
    fechaSubida: '2024-01-14',
    subidoPor: 'Carlos Ramírez',
    estado: 'vigente'
  },
  {
    id: '4',
    nombre: 'CERTIFICADO_ORIGEN_CN.pdf',
    tipo: 'Certificado de Origen',
    operacion: 'OP-2024-1815',
    cliente: 'Exportadora del Sur Ltda.',
    carpeta: 'Permisos',
    tamaño: '1.2 MB',
    fechaSubida: '2024-01-14',
    subidoPor: 'Ana Torres',
    estado: 'pendiente'
  },
  {
    id: '5',
    nombre: 'PACKING_LIST_1815.xlsx',
    tipo: 'Packing List',
    operacion: 'OP-2024-1815',
    cliente: 'Exportadora del Sur Ltda.',
    carpeta: 'Otros',
    tamaño: '856 KB',
    fechaSubida: '2024-01-13',
    subidoPor: 'Ana Torres',
    estado: 'vigente'
  },
  {
    id: '6',
    nombre: 'PERMISO_SANITARIO_1808.pdf',
    tipo: 'Permiso Sanitario',
    operacion: 'OP-2024-1808',
    cliente: 'Comercial Andina S.A.C.',
    carpeta: 'Permisos',
    tamaño: '2.1 MB',
    fechaSubida: '2024-01-12',
    subidoPor: 'Luis Mendoza',
    estado: 'vencido'
  },
  {
    id: '7',
    nombre: 'AWB_LATAM_2024001801.pdf',
    tipo: 'Air Waybill',
    operacion: 'OP-2024-1801',
    cliente: 'Distribuidora Pacífico E.I.R.L.',
    carpeta: 'BL/AWB',
    tamaño: '1.5 MB',
    fechaSubida: '2024-01-11',
    subidoPor: 'María González',
    estado: 'vigente'
  },
  {
    id: '8',
    nombre: 'MANIFIESTO_CARGA_1795.pdf',
    tipo: 'Manifiesto de Carga',
    operacion: 'OP-2024-1795',
    cliente: 'Logística Internacional Corp.',
    carpeta: 'Otros',
    tamaño: '4.3 MB',
    fechaSubida: '2024-01-10',
    subidoPor: 'Carlos Ramírez',
    estado: 'vigente'
  },
  {
    id: '9',
    nombre: 'DUCA_SV_2024_001788.pdf',
    tipo: 'DUCA',
    operacion: 'OP-2024-1788',
    cliente: 'Importadora Global S.A.',
    carpeta: 'DUCA',
    tamaño: '2.9 MB',
    fechaSubida: '2024-01-09',
    subidoPor: 'Ana Torres',
    estado: 'vigente'
  },
  {
    id: '10',
    nombre: 'FACTURA_COMERCIAL_1780.pdf',
    tipo: 'Factura Comercial',
    operacion: 'OP-2024-1780',
    cliente: 'Textiles Modernos S.A.',
    carpeta: 'Facturas',
    tamaño: '1.1 MB',
    fechaSubida: '2024-01-08',
    subidoPor: 'Luis Mendoza',
    estado: 'vigente'
  }
];

const carpetas = [
  { id: 'todas', nombre: 'Todas', icon: 'ri-folder-line', count: 10 },
  { id: 'DUCA', nombre: 'DUCA', icon: 'ri-file-text-line', count: 2 },
  { id: 'Facturas', nombre: 'Facturas', icon: 'ri-bill-line', count: 2 },
  { id: 'BL/AWB', nombre: 'BL/AWB', icon: 'ri-ship-line', count: 2 },
  { id: 'Permisos', nombre: 'Permisos', icon: 'ri-shield-check-line', count: 2 },
  { id: 'Otros', nombre: 'Otros', icon: 'ri-folder-2-line', count: 2 }
];

export default function OperationsDocuments() {
  const [selectedCarpeta, setSelectedCarpeta] = useState('todas');
  const [searchTerm, setSearchTerm] = useState('');
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState<Document | null>(null);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [viewMode, setViewMode] = useState<'list' | 'grid'>('list');

  const displayToast = (message: string) => {
    setToastMessage(message);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
  };

  const getEstadoColor = (estado: string) => {
    switch (estado) {
      case 'vigente': return 'bg-[#10B981]/10 text-[#10B981]';
      case 'vencido': return 'bg-[#EF4444]/10 text-[#EF4444]';
      case 'pendiente': return 'bg-[#F59E0B]/10 text-[#F59E0B]';
      default: return 'bg-gray-100 text-gray-700';
    }
  };

  const getFileIcon = (tipo: string) => {
    if (tipo.includes('pdf')) return 'ri-file-pdf-line text-[#EF4444]';
    if (tipo.includes('xlsx') || tipo.includes('xls')) return 'ri-file-excel-line text-[#10B981]';
    if (tipo.includes('doc')) return 'ri-file-word-line text-[#2F80ED]';
    if (tipo.includes('jpg') || tipo.includes('png')) return 'ri-image-line text-[#F59E0B]';
    return 'ri-file-line text-[#6B7280]';
  };

  const filteredDocs = documentsData.filter(doc => {
    if (selectedCarpeta !== 'todas' && doc.carpeta !== selectedCarpeta) return false;
    if (searchTerm && !doc.nombre.toLowerCase().includes(searchTerm.toLowerCase()) && 
        !doc.operacion.toLowerCase().includes(searchTerm.toLowerCase()) &&
        !doc.cliente.toLowerCase().includes(searchTerm.toLowerCase())) return false;
    return true;
  });

  return (
    <Layout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-[#0A2A43]">Centro Documental</h1>
            <p className="text-sm text-[#6B7280] mt-1">Gestión centralizada de documentos operativos</p>
          </div>
          <div className="flex items-center gap-3">
            <button className="px-4 py-2.5 border border-gray-200 text-[#6B7280] rounded-md hover:bg-gray-50 cursor-pointer whitespace-nowrap">
              <i className="ri-download-line mr-2"></i>Descargar Selección
            </button>
            <button 
              onClick={() => setShowUploadModal(true)}
              className="px-4 py-2.5 bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white rounded-md hover:shadow-md cursor-pointer whitespace-nowrap"
            >
              <i className="ri-upload-cloud-line mr-2"></i>Subir Documentos
            </button>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-5 gap-4">
          <div className="bg-white rounded-lg border border-gray-200 p-4">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm text-[#6B7280]">Total Documentos</span>
              <div className="w-8 h-8 rounded-lg bg-[#0A2A43]/10 flex items-center justify-center">
                <i className="ri-file-list-3-line text-[#0A2A43]"></i>
              </div>
            </div>
            <p className="text-2xl font-bold text-[#0A2A43]">248</p>
          </div>
          <div className="bg-white rounded-lg border border-gray-200 p-4">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm text-[#6B7280]">Este Mes</span>
              <div className="w-8 h-8 rounded-lg bg-[#2F80ED]/10 flex items-center justify-center">
                <i className="ri-calendar-line text-[#2F80ED]"></i>
              </div>
            </div>
            <p className="text-2xl font-bold text-[#2F80ED]">42</p>
          </div>
          <div className="bg-white rounded-lg border border-gray-200 p-4">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm text-[#6B7280]">Vigentes</span>
              <div className="w-8 h-8 rounded-lg bg-[#10B981]/10 flex items-center justify-center">
                <i className="ri-check-double-line text-[#10B981]"></i>
              </div>
            </div>
            <p className="text-2xl font-bold text-[#10B981]">235</p>
          </div>
          <div className="bg-white rounded-lg border border-gray-200 p-4">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm text-[#6B7280]">Pendientes</span>
              <div className="w-8 h-8 rounded-lg bg-[#F59E0B]/10 flex items-center justify-center">
                <i className="ri-time-line text-[#F59E0B]"></i>
              </div>
            </div>
            <p className="text-2xl font-bold text-[#F59E0B]">8</p>
          </div>
          <div className="bg-white rounded-lg border border-gray-200 p-4">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm text-[#6B7280]">Vencidos</span>
              <div className="w-8 h-8 rounded-lg bg-[#EF4444]/10 flex items-center justify-center">
                <i className="ri-error-warning-line text-[#EF4444]"></i>
              </div>
            </div>
            <p className="text-2xl font-bold text-[#EF4444]">5</p>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-6">
          {/* Sidebar Carpetas */}
          <div className="col-span-3">
            <div className="bg-white rounded-lg border border-gray-200 p-4">
              <h3 className="text-sm font-semibold text-[#0A2A43] mb-4">Carpetas</h3>
              <ul className="space-y-1">
                {carpetas.map((carpeta) => (
                  <li key={carpeta.id}>
                    <button
                      onClick={() => setSelectedCarpeta(carpeta.id)}
                      className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition-all cursor-pointer ${
                        selectedCarpeta === carpeta.id
                          ? 'bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white'
                          : 'text-[#6B7280] hover:bg-[#EAF2F8]'
                      }`}
                    >
                      <i className={carpeta.icon}></i>
                      <span className="flex-1 text-left">{carpeta.nombre}</span>
                      <span className={`text-xs px-2 py-0.5 rounded-full ${
                        selectedCarpeta === carpeta.id ? 'bg-white/20' : 'bg-gray-100'
                      }`}>
                        {carpeta.count}
                      </span>
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Main Content */}
          <div className="col-span-9 space-y-4">
            {/* Search and Filters */}
            <div className="bg-white rounded-lg border border-gray-200 p-4">
              <div className="flex items-center gap-4">
                <div className="flex-1 relative">
                  <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-[#6B7280]"></i>
                  <input
                    type="text"
                    placeholder="Buscar por nombre, operación o cliente..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full pl-10 pr-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]"
                  />
                </div>
                <select className="px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]">
                  <option>Todos los tipos</option>
                  <option>Bill of Lading</option>
                  <option>Factura Comercial</option>
                  <option>DUCA</option>
                  <option>Certificado de Origen</option>
                  <option>Packing List</option>
                </select>
                <select className="px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]">
                  <option>Todos los estados</option>
                  <option>Vigentes</option>
                  <option>Pendientes</option>
                  <option>Vencidos</option>
                </select>
                <div className="flex items-center border border-gray-200 rounded-md">
                  <button
                    onClick={() => setViewMode('list')}
                    className={`px-3 py-2 cursor-pointer ${viewMode === 'list' ? 'bg-[#EAF2F8] text-[#0A2A43]' : 'text-[#6B7280]'}`}
                  >
                    <i className="ri-list-check"></i>
                  </button>
                  <button
                    onClick={() => setViewMode('grid')}
                    className={`px-3 py-2 cursor-pointer ${viewMode === 'grid' ? 'bg-[#EAF2F8] text-[#0A2A43]' : 'text-[#6B7280]'}`}
                  >
                    <i className="ri-grid-line"></i>
                  </button>
                </div>
              </div>
            </div>

            {/* Documents List/Grid */}
            {viewMode === 'list' ? (
              <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                <div className="overflow-x-auto">
                  <table className="w-full">
                    <thead className="bg-gray-50 border-b border-gray-200">
                      <tr>
                        <th className="px-4 py-3 text-left">
                          <input type="checkbox" className="rounded border-gray-300" />
                        </th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-[#6B7280] uppercase">Documento</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-[#6B7280] uppercase">Operación</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-[#6B7280] uppercase">Carpeta</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-[#6B7280] uppercase">Tamaño</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-[#6B7280] uppercase">Fecha</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-[#6B7280] uppercase">Estado</th>
                        <th className="px-4 py-3 text-right text-xs font-semibold text-[#6B7280] uppercase">Acciones</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                      {filteredDocs.map((doc) => (
                        <tr key={doc.id} className="hover:bg-gray-50 transition-colors">
                          <td className="px-4 py-4">
                            <input type="checkbox" className="rounded border-gray-300" />
                          </td>
                          <td className="px-4 py-4">
                            <div className="flex items-center gap-3">
                              <div className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center">
                                <i className={`${getFileIcon(doc.nombre)} text-xl`}></i>
                              </div>
                              <div>
                                <p className="text-sm font-medium text-[#0A2A43]">{doc.nombre}</p>
                                <p className="text-xs text-[#6B7280]">{doc.tipo}</p>
                              </div>
                            </div>
                          </td>
                          <td className="px-4 py-4">
                            <p className="text-sm font-medium text-[#2F80ED]">{doc.operacion}</p>
                            <p className="text-xs text-[#6B7280]">{doc.cliente}</p>
                          </td>
                          <td className="px-4 py-4">
                            <span className="text-sm text-[#6B7280]">{doc.carpeta}</span>
                          </td>
                          <td className="px-4 py-4">
                            <span className="text-sm text-[#6B7280]">{doc.tamaño}</span>
                          </td>
                          <td className="px-4 py-4">
                            <p className="text-sm text-[#0A2A43]">{doc.fechaSubida}</p>
                            <p className="text-xs text-[#6B7280]">{doc.subidoPor}</p>
                          </td>
                          <td className="px-4 py-4">
                            <span className={`inline-flex px-2.5 py-1 rounded-full text-xs font-medium ${getEstadoColor(doc.estado)}`}>
                              {doc.estado.charAt(0).toUpperCase() + doc.estado.slice(1)}
                            </span>
                          </td>
                          <td className="px-4 py-4">
                            <div className="flex items-center justify-end gap-2">
                              <button
                                onClick={() => {
                                  setSelectedDoc(doc);
                                  setShowPreviewModal(true);
                                }}
                                className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-gray-100 cursor-pointer"
                                title="Vista previa"
                              >
                                <i className="ri-eye-line text-[#6B7280]"></i>
                              </button>
                              <button 
                                onClick={() => displayToast(`Descargando ${doc.nombre}...`)}
                                className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-gray-100 cursor-pointer" 
                                title="Descargar"
                              >
                                <i className="ri-download-line text-[#6B7280]"></i>
                              </button>
                              <button className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-gray-100 cursor-pointer" title="Más opciones">
                                <i className="ri-more-2-fill text-[#6B7280]"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div className="grid grid-cols-4 gap-4">
                {filteredDocs.map((doc) => (
                  <div key={doc.id} className="bg-white rounded-lg border border-gray-200 p-4 hover:shadow-md transition-all cursor-pointer">
                    <div className="flex items-center justify-between mb-3">
                      <div className="w-12 h-12 rounded-lg bg-gray-100 flex items-center justify-center">
                        <i className={`${getFileIcon(doc.nombre)} text-2xl`}></i>
                      </div>
                      <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${getEstadoColor(doc.estado)}`}>
                        {doc.estado.charAt(0).toUpperCase() + doc.estado.slice(1)}
                      </span>
                    </div>
                    <h4 className="text-sm font-medium text-[#0A2A43] truncate mb-1">{doc.nombre}</h4>
                    <p className="text-xs text-[#6B7280] mb-2">{doc.tipo}</p>
                    <div className="flex items-center justify-between text-xs text-[#6B7280]">
                      <span>{doc.tamaño}</span>
                      <span>{doc.fechaSubida}</span>
                    </div>
                    <div className="flex items-center gap-2 mt-3 pt-3 border-t border-gray-100">
                      <button 
                        onClick={() => {
                          setSelectedDoc(doc);
                          setShowPreviewModal(true);
                        }}
                        className="flex-1 py-1.5 text-xs text-[#6B7280] hover:bg-gray-100 rounded cursor-pointer"
                      >
                        <i className="ri-eye-line mr-1"></i>Ver
                      </button>
                      <button 
                        onClick={() => displayToast(`Descargando ${doc.nombre}...`)}
                        className="flex-1 py-1.5 text-xs text-[#2F80ED] hover:bg-[#EAF2F8] rounded cursor-pointer"
                      >
                        <i className="ri-download-line mr-1"></i>Descargar
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Modal Subir Documentos */}
      {showUploadModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-full max-w-2xl mx-4 max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b border-gray-200 flex items-center justify-between">
              <h2 className="text-xl font-bold text-[#0A2A43]">Subir Documentos</h2>
              <button onClick={() => setShowUploadModal(false)} className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-gray-100 cursor-pointer">
                <i className="ri-close-line text-xl text-[#6B7280]"></i>
              </button>
            </div>
            <div className="p-6 space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Operación Asociada *</label>
                  <select className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]">
                    <option>Seleccionar operación...</option>
                    <option>OP-2024-1823 - Importadora Global S.A.</option>
                    <option>OP-2024-1815 - Exportadora del Sur Ltda.</option>
                    <option>OP-2024-1808 - Comercial Andina S.A.C.</option>
                    <option>OP-2024-1801 - Distribuidora Pacífico E.I.R.L.</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Carpeta *</label>
                  <select className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]">
                    <option>Seleccionar carpeta...</option>
                    <option>DUCA</option>
                    <option>Facturas</option>
                    <option>BL/AWB</option>
                    <option>Permisos</option>
                    <option>Otros</option>
                  </select>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Tipo de Documento *</label>
                <select className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]">
                  <option>Seleccionar tipo...</option>
                  <option>Bill of Lading</option>
                  <option>Air Waybill</option>
                  <option>Factura Comercial</option>
                  <option>DUCA</option>
                  <option>Certificado de Origen</option>
                  <option>Packing List</option>
                  <option>Permiso Sanitario</option>
                  <option>Manifiesto de Carga</option>
                  <option>Otro</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Archivos *</label>
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center hover:border-[#2F80ED] transition-colors cursor-pointer">
                  <i className="ri-upload-cloud-line text-4xl text-[#6B7280] mb-2"></i>
                  <p className="text-sm text-[#6B7280]">Arrastra archivos aquí o haz clic para seleccionar</p>
                  <p className="text-xs text-gray-400 mt-1">PDF, JPG, PNG, XLSX hasta 10MB cada uno</p>
                  <p className="text-xs text-[#2F80ED] mt-2">Puedes subir múltiples archivos</p>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Notas (opcional)</label>
                <textarea 
                  rows={2} 
                  placeholder="Notas adicionales sobre los documentos..." 
                  className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]"
                  maxLength={500}
                ></textarea>
              </div>
            </div>
            <div className="p-6 border-t border-gray-200 flex justify-end gap-3">
              <button onClick={() => setShowUploadModal(false)} className="px-4 py-2.5 border border-gray-200 text-[#6B7280] rounded-md hover:bg-gray-50 cursor-pointer whitespace-nowrap">
                Cancelar
              </button>
              <button 
                onClick={() => {
                  setShowUploadModal(false);
                  displayToast('Documentos subidos exitosamente');
                }}
                className="px-4 py-2.5 bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white rounded-md hover:shadow-md cursor-pointer whitespace-nowrap"
              >
                Subir Documentos
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Vista Previa */}
      {showPreviewModal && selectedDoc && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-full max-w-4xl mx-4 max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b border-gray-200 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center">
                  <i className={`${getFileIcon(selectedDoc.nombre)} text-xl`}></i>
                </div>
                <div>
                  <h2 className="text-lg font-bold text-[#0A2A43]">{selectedDoc.nombre}</h2>
                  <p className="text-sm text-[#6B7280]">{selectedDoc.tipo} • {selectedDoc.tamaño}</p>
                </div>
              </div>
              <button onClick={() => setShowPreviewModal(false)} className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-gray-100 cursor-pointer">
                <i className="ri-close-line text-xl text-[#6B7280]"></i>
              </button>
            </div>
            <div className="p-6">
              <div className="bg-gray-100 rounded-lg h-96 flex items-center justify-center">
                <div className="text-center">
                  <i className={`${getFileIcon(selectedDoc.nombre)} text-6xl mb-4`}></i>
                  <p className="text-sm text-[#6B7280]">Vista previa del documento</p>
                  <p className="text-xs text-gray-400 mt-1">{selectedDoc.nombre}</p>
                </div>
              </div>
              <div className="grid grid-cols-4 gap-4 mt-6">
                <div>
                  <label className="block text-xs font-medium text-[#6B7280] mb-1">Operación</label>
                  <p className="text-sm font-medium text-[#2F80ED]">{selectedDoc.operacion}</p>
                </div>
                <div>
                  <label className="block text-xs font-medium text-[#6B7280] mb-1">Cliente</label>
                  <p className="text-sm font-medium text-[#0A2A43]">{selectedDoc.cliente}</p>
                </div>
                <div>
                  <label className="block text-xs font-medium text-[#6B7280] mb-1">Subido por</label>
                  <p className="text-sm font-medium text-[#0A2A43]">{selectedDoc.subidoPor}</p>
                </div>
                <div>
                  <label className="block text-xs font-medium text-[#6B7280] mb-1">Estado</label>
                  <span className={`inline-flex px-2.5 py-1 rounded-full text-xs font-medium ${getEstadoColor(selectedDoc.estado)}`}>
                    {selectedDoc.estado.charAt(0).toUpperCase() + selectedDoc.estado.slice(1)}
                  </span>
                </div>
              </div>
            </div>
            <div className="p-6 border-t border-gray-200 flex justify-end gap-3">
              <button onClick={() => setShowPreviewModal(false)} className="px-4 py-2.5 border border-gray-200 text-[#6B7280] rounded-md hover:bg-gray-50 cursor-pointer whitespace-nowrap">
                Cerrar
              </button>
              <button 
                onClick={() => {
                  displayToast(`Descargando ${selectedDoc.nombre}...`);
                  setShowPreviewModal(false);
                }}
                className="px-4 py-2.5 bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white rounded-md hover:shadow-md cursor-pointer whitespace-nowrap"
              >
                <i className="ri-download-line mr-2"></i>Descargar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Toast */}
      {showToast && (
        <div className="fixed bottom-6 right-6 bg-[#10B981] text-white px-6 py-4 rounded-lg shadow-lg flex items-center gap-3 z-50 animate-pulse">
          <i className="ri-check-circle-line text-xl"></i>
          <span className="font-medium">{toastMessage}</span>
        </div>
      )}
    </Layout>
  );
}
